module.exports = __webpack_public_path__ + "img/title1.e4a4a78f.png";